import React from 'react';

import Flex from './Flex';

import { getTileClasses } from './shared/utils';

import type { Value } from '@fshr/shared/types';

type TileGroupProps = {
	className?: string;
	count?: number;
	dateTransform: (point: number) => Date;
	end: number;
	offset?: number;
	renderTile: (props: { classes: string[]; date: Date }) => React.ReactElement;
	start: number;
	step?: number;
	value?: Value;
	nightlyRatesExperiment?: boolean;
};

export default function TileGroup({
	className,
	count = 3,
	dateTransform,
	end,
	offset,
	renderTile,
	start,
	step = 1,
	value,
	nightlyRatesExperiment,
}: TileGroupProps) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const tiles: React.ReactElement<any, string | React.JSXElementConstructor<any>>[] = [];
	for (let point = start; point <= end; point += step) {
		const date = dateTransform(point);

		tiles.push(
			renderTile({
				classes: getTileClasses(
					{
						date,
						value,
					},
					undefined,
					nightlyRatesExperiment
				),
				date,
			})
		);
	}

	return (
		<Flex className={className} count={count} offset={offset} wrap>
			{tiles}
		</Flex>
	);
}
